<template>
  <article class="popup del-thing">
    <header class="header popup-top">
      <h2 v-if="!thing.virtual" class="title">
        {{$t('things.headerSingle.del')}}
      </h2>
      <h2 v-else class="title">
        {{$t('things.headerSingle.delMulti')}}
      </h2>
      <div class="popup-top_btns">
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <div class="content">
      <span v-if="!thing.virtual" class="big">{{$t('things.delThingConfirm')}}<br>
        <span v-for="(name,i) in delName" :key="name + i">"{{name}}"<br></span>
      </span>
      <span v-else class="big">{{$t('things.delMultithingConfirm')}}<br>
        <span v-for="(name,i) in delName" :key="name + i">"{{name}}"<br></span>
      </span>
      <span v-if="!thing.virtual" class="small">{{$t('things.delThingDesc')}}</span>
      <span v-else class="small">{{$t('things.delMultithingDesc')}}</span>
    </div>
    <div class="btn-cont">
      <button type="button"
              @click="closeAll"
              class="btn btn-transparent_dark">
        {{$t('btns.cancel')}}
      </button>
      <button type="button"
              @click="delThingNow"
              class="btn-transparent_red btn">
        {{$t('btns.accept')}}
      </button>
    </div>
  </article>
</template>

<script>
  import closeBtn from '../../closeBtn'
  import {mapState, mapMutations, mapActions} from 'vuex'
  import {popups} from "../../../../mixins/popups";

  export default {
    name: 'delThing',
    mixins: [popups],
    components: {
      closeBtn
    },
    computed: {
      ...mapState({
        delName: state => state.things.delName,
        thing: state => state.things.device,
      })
    },
    methods: {
      ...mapMutations({
        setConfirm: 'things/SET_CONFIRM'
      }),
      ...mapActions({
        deleteDevice: 'things/deleteDevice',
        getDevices: 'things/getDevices',

      }),
      async delThingNow() {
        await this.deleteDevice(this.$route.params.id)
        this.closeAll();
        // this.confirm()
        await this.getDevices()
        this.$router.push({ name: 'things' })
      },

      confirm() {
        this.setConfirm(true);
        this.closeAll();
      }
    },
    mounted() {
    }
  }
</script>

<style lang="scss" scoped>
.del-thing {
  padding: 0;
}

  .header {
    padding: 30px;
    margin-bottom: 30px;
  }

  .content {
    padding: 30px;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .big {
    font-family: $msb;
    font-size: 21px;
    letter-spacing: .15px;
    margin-bottom: 20px;
  }

  .small {
    font-family: $mr;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .btn-cont {
    margin: 0 30px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    button {
      width: calc(50% - 10px);
    }
  }
</style>
